import React, { useEffect } from 'react';
import styled from 'styled-components';
import SectionHeader from '../components/SectionHeader';
import teamBg from '../assets/images/team-bg.jpg';

const TeamSection = styled.section`
  background: linear-gradient(rgba(18, 25, 16, 0.9), rgba(18, 25, 16, 0.9)), url(${teamBg});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
`;

const TeamCard = styled.div`
  display: flex;
  background-color: rgba(30, 43, 15, 0.8);
  border: 1px solid var(--primary-color);
  border-radius: 8px;
  overflow: hidden;
  max-width: 800px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  margin: 0 auto 40px;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
  
  &.animate {
    opacity: 1;
    transform: translateY(0);
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const TeamNumber = styled.div`
  background-color: var(--primary-color);
  color: var(--secondary-color);
  font-size: 2.5rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  min-width: 100px;
  
  @media (max-width: 768px) {
    min-width: 100%;
    padding: 10px;
  }
`;

const TeamDetail = styled.div`
  padding: 30px;
  
  h3 {
    color: var(--secondary-color);
    margin-bottom: 15px;
  }
  
  p {
    font-size: 1.1rem;
    line-height: 1.6;
    
    @media (max-width: 576px) {
      font-size: 1rem;
    }
  }
`;

const TeamStructure = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 30px;
  margin-top: 50px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const TeamUnit = styled.div`
  background-color: rgba(30, 43, 15, 0.8);
  border: 1px solid var(--primary-color);
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  transition: all 0.3s ease;
  flex: 1;
  min-width: 250px;
  max-width: 350px;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
  transition-delay: ${props => props.delay || '0s'};
  
  &.animate {
    opacity: 1;
    transform: translateY(0);
  }
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    border-color: var(--secondary-color);
  }
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const UnitIcon = styled.div`
  font-size: 2.5rem;
  color: var(--secondary-color);
  margin-bottom: 20px;
`;

const Team = () => {
  useEffect(() => {
    const handleScroll = () => {
      const teamCard = document.getElementById('team-card');
      const teamUnits = document.querySelectorAll('.team-unit');
      
      if (teamCard) {
        const position = teamCard.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        if (position.top < windowHeight * 0.75) {
          teamCard.classList.add('animate');
        }
      }
      
      teamUnits.forEach(unit => {
        const position = unit.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        if (position.top < windowHeight * 0.75) {
          unit.classList.add('animate');
        }
      });
    };
    
    window.addEventListener('scroll', handleScroll);
    // Initial check
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  return (
    <TeamSection id="time">
      <div className="container">
        <SectionHeader title="Nosso Time" highlight="Time" />
        <TeamCard id="team-card">
          <TeamNumber>03</TeamNumber>
          <TeamDetail>
            <h3>Estrutura da Equipe</h3>
            <p>
              Nossa equipe dedicada está organizada em unidades estratégicas, 
              incluindo desenvolvimento, design e suporte ao cliente, garantindo 
              uma colaboração eficaz e uma execução de projetos eficiente.
            </p>
          </TeamDetail>
        </TeamCard>
        <TeamStructure>
          <TeamUnit className="team-unit" delay="0s">
            <UnitIcon>
              <i className="fas fa-code"></i>
            </UnitIcon>
            <h4>Desenvolvimento</h4>
            <p>Especialistas em diversas linguagens e frameworks</p>
          </TeamUnit>
          <TeamUnit className="team-unit" delay="0.2s">
            <UnitIcon>
              <i className="fas fa-paint-brush"></i>
            </UnitIcon>
            <h4>Design</h4>
            <p>Criadores de interfaces intuitivas e impactantes</p>
          </TeamUnit>
          <TeamUnit className="team-unit" delay="0.4s">
            <UnitIcon>
              <i className="fas fa-headset"></i>
            </UnitIcon>
            <h4>Suporte</h4>
            <p>Prontos para auxiliar em qualquer situação</p>
          </TeamUnit>
        </TeamStructure>
      </div>
    </TeamSection>
  );
};

export default Team;
